import { Component, Input } from '@angular/core';
import { RequisitionsPieChartData, RequisitionsChartMonthlyData, RequisitionsChartWeeklyData } from '../../models/requisitions-pie-chart-data.model';
import {CurrencyPipe, PercentPipe} from '@angular/common';

@Component({
  selector: 'app-requisition-pie-chart',
  templateUrl: './requisition-pie-chart.component.html',
  styleUrl: './requisition-pie-chart.component.scss'
})
export class RequisitionPieChartComponent{
  dataArray1: any[] = [];
  totalAmount: number = 0;
  percentPipe = new PercentPipe('en-US');
  currencyPipe = new CurrencyPipe('en-US');
  option: "A" | "B" | "C" = "A"
  viewMonthly: boolean = false;
  viewWeekly: boolean = false;

  @Input() chart: 'chart1' | 'chart2' = 'chart1';

  private _pieChartDataSource: RequisitionsPieChartData = {} as RequisitionsPieChartData;
  @Input()
  set pieChartDataSource(value: RequisitionsPieChartData) {
    if (this.chart === 'chart1') {
      this.dataArray1 = [
        {
          title: 'Editando',
          count: value.totalAmount - (value.totalPendingAuthorization + value.totalAuthorized),
        },
        {
          title: 'Por autorizar',
          count: value.totalPendingAuthorization,
        },
        {
          title: 'Autorizadas',
          count: value.totalAuthorized,
        },
      ]
      this._pieChartDataSource = value;
      this.totalAmount = value.totalAmount;
    } else {
      this.dataArray1 = [
        {
          title: 'Comprando',
          count: value.totalToPurchase,
        },
        {
          title: 'Compradas',
          count: value.totalPurchased,
        },
      ]
      this._pieChartDataSource = value;
      this.totalAmount = value.totalToPurchase + value.totalPurchased;
    }
  }
  get pieChartDataSource(): RequisitionsPieChartData {
    return this._pieChartDataSource;
  }

  private _chartMonthlyDataSource: RequisitionsChartMonthlyData[] = [];
  @Input()
  set chartMonthlyDataSource(value: RequisitionsChartMonthlyData[]) {
    if (value === null || value === undefined || value.length === 0) {
      this.viewMonthly = false;
      return;
    }
    this.viewMonthly = true;
    const monthNames = [
      'Ene.', 'Feb.', 'Mar.', 'Abr.', 'May.', 'Jun.',
      'Jul.', 'Ago.', 'Sep.', 'Oct.', 'Nov.', 'Dic.'
    ];

    const result = value.map(item => {
      const date = new Date(item.month);
      return { ...item, month: monthNames[date.getMonth()] };
    });

    this._chartMonthlyDataSource = result;
  }
  get chartMonthlyDataSource(): RequisitionsChartMonthlyData[] {
    return this._chartMonthlyDataSource;
  }

  private _chartWeeklyDataSource: RequisitionsChartWeeklyData[] = [];
  @Input()
  set chartWeeklyDataSource(value: RequisitionsChartWeeklyData[]) {
    if (value === null || value === undefined || value.length === 0) {
      this.viewWeekly = false;
      return;
    }
    this.viewWeekly = true;
    const dataConFormato = value.map(item => {
      const fechaInicio = new Date(item.weekStart);
      const fechaFormateada = fechaInicio.toLocaleDateString('es-ES', { day: 'numeric', month: 'short' });
      return {
        ...item,
        weekStart: `Semana del ${fechaFormateada}`
      };
    });

    this._chartWeeklyDataSource = dataConFormato;
  }
  get chartWeeklyDataSource(): RequisitionsChartWeeklyData[] {
    return this._chartWeeklyDataSource;
  }

  constructor() { }

  customizePoint(point: any) {
    const color = point.series.getPointsByArg(point.argument)[0].getColor();
    switch (point.argument) {
      case 'Editando':
        return { color: 'rgba(0,0,0,0.06)', hoverStyle: { color: 'rgba(0,0,0,0.06)' } };
      case 'Por autorizar':
        return { color: '#6DB4FE', hoverStyle: { color: '#6DB4FE' } };
      case 'Autorizadas':
        return { color: '#021F79', hoverStyle: { color: '#021F79' } };
      case 'Comprando':
        return { color: 'rgba(0,0,0,0.06)', hoverStyle: { color: 'rgba(0,0,0,0.06)' } };
      case 'Compradas':
        return { color: '#021F79', hoverStyle: { color: '#021F79' } };
      default:
        return { color: color, hoverStyle: { color: color } };
    }
  }

  customizeTooltip = ({ percent }: {percent: number }) => ({
    text: `${this.percentPipe.transform(percent, '1.2-2')}`,
  });

  getMarkerColor(item:any) {
    return item.marker.fill;
  }

  customizeLegendText(item: any): string {
    return '';
  }

  customizeTooltipBars = ({ value }: {value: string }) =>  {
     return {
       text: `${this.currencyPipe.transform(value)}`,
     }
  }

}


